// VERSION 1.0.0
// AUTHOR: AGALYA

const TransferCenterActionTypes = {
	/*************** CREATE TRANSFER LOG START  ******************/
	CREATE_TRANSFER_LOG_START: 'create_transfer_log_start',
	CREATE_TRANSFER_LOG_SUCCESS: 'create_transfer_log_success',
	CREATE_TRANSFER_LOG_FAILURE: 'create_transfer_log_failure',
	CREATE_TRANSFER_LOG_RESPONSE_RESET_START: 'create_transfer_log_response_reset_start',
	CREATE_TRANSFER_LOG_RESPONSE_CHANGED: 'create_transfer_log_response_changed',
	/*************** CREATE TRANSFER LOG END  ******************/

	/*************** MEMBER CENTER TRANSFER START  ******************/
	CREATE_CENTER_TRANSFER_START: 'create_center_transfer_start',
	CREATE_CENTER_TRANSFER_SUCCESS: 'create_center_transfer_success',
	CREATE_CENTER_TRANSFER_FAILURE: 'create_center_transfer_failure',
	CREATE_CENTER_TRANSFER_RESPONSE_RESET_START: 'create_center_transfer_response_reset_start',
	CREATE_CENTER_TRANSFER_RESPONSE_CHANGED: 'create_center_transfer_response_changed',
	/*************** CREATE CENTER TRANSFER END  ******************/

	/*************** FETCH TRANSFER CENTER START  ******************/
	FETCH_TRANSFER_CENTER_DETAILS_START: 'fetch_transfer_center_details_start',
	FETCH_TRANSFER_CENTER_DETAILS_SUCCESS: 'fetch_transfer_center_details_success',
	FETCH_TRANSFER_CENTER_DETAILS_FAILURE: 'fetch_transfer_center_details_failure',
	FETCH_TRANSFER_CENTER_DETAILS_RESPONSE_RESET_START:
		'fetch_transfer_center_details_response_reset_start',
	FETCH_TRANSFER_CENTER_DETAILS_RESPONSE_CHANGED:
		'fetch_transfer_center_details_response_changed',
	/*************** FETCH TRANSFER CENTER END  ******************/

	/*************** FETCH TRANSFER GROUP START  ******************/
	FETCH_TRANSFER_GROUP_DETAILS_START: 'fetch_transfer_group_details_start',
	FETCH_TRANSFER_GROUP_DETAILS_SUCCESS: 'fetch_transfer_group_details_success',
	FETCH_TRANSFER_GROUP_DETAILS_FAILURE: 'fetch_transfer_group_details_failure',
	FETCH_TRANSFER_GROUP_DETAILS_RESPONSE_RESET_START:
		'fetch_transfer_group_details_response_reset_start',
	FETCH_TRANSFER_GROUP_DETAILS_RESPONSE_CHANGED: 'fetch_transfer_group_details_response_changed',
	/*************** FETCH TRANSFER GROUP END  ******************/
};

export default TransferCenterActionTypes;
